import './not-found.scss';

import React from 'react';

interface IProp {
  message?: string;
}

export function NotFound(prop: IProp) {
  const message = prop.message || 'Not found';
  return (
    <div className="not-found">
      <h1>404</h1>
      {message}
    </div>
  );
}
